{
	"customElements": [
		"lev-content"
	],
	"elements": [
		"a",
		"abbr",
		"acronym",
		"address",
		"area",
		"b",
		"bdo",
		"big",
		"blockquote",
		"br",
		"caption",
		"center",
		"cite",
		"code",
		"col",
		"colgroup",
		"dd",
		"del",
		"dfn",
		"#div",
		"dl",
		"dt",
		"em",
		"font",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"hr",
		"i",
		"img",
		"ins",
		"kbd",
		"li",
		"map",
		"ol",
		"#p",
		"pre",
		"q",
		"s",
		"samp",
		"small",
		"span",
		"strike",
		"strong",
		"sub",
		"sup",
		"svg",
		"g",
		"path",
		"text",
		"tspan",
		"table",
		"tbody",
		"td",
		"tfoot",
		"th",
		"thead",
		"tr",
		"tt",
		"u",
		"ul",
		"var"
	],
	"commonAttrs": [
		"dir",
		"lang",
		"style",
		"title",
		"contenteditable",
		"class"
	],
	"attrMap": {
		"lev-content": [
			"bgcolor",
			"text",
			"xmlns"
		],
		"a": [
			"charset",
			"coords",
			"href",
			"hreflang",
			"name",
			"rel",
			"rev",
			"shape",
			"tabindex",
			"target",
			"type"
		],
		"area": [
			"alt",
			"coords",
			"href",
			"nohref",
			"shape",
			"tabindex",
			"target"
		],
		"blockquote": [
			"cite"
		],
		"br": [
			"clear"
		],
		"caption": [
			"align"
		],
		"col": [
			"align",
			"char",
			"charoff",
			"valign"
		],
		"colgroup": [
			"align",
			"char",
			"charoff",
			"span",
			"valign",
			"width"
		],
		"del": [
			"cite",
			"datetime"
		],
		"#div": [
			"align"
		],
		"dl": [
			"compact"
		],
		"font": [
			"size",
			"color",
			"face"
		],
		"h1": [
			"align"
		],
		"h2": [
			"align"
		],
		"h3": [
			"align"
		],
		"h4": [
			"align"
		],
		"h5": [
			"align"
		],
		"h6": [
			"align"
		],
		"hr": [
			"align",
			"noshade",
			"size",
			"width"
		],
		"img": [
			"align",
			"alt",
			"border",
			"height",
			"hspace",
			"ismap",
			"longdesc",
			"name",
			"src",
			"usemap",
			"vspace",
			"width"
		],
		"ins": [
			"cite",
			"datetime"
		],
		"li": [
			"type",
			"value"
		],
		"map": [
			"name"
		],
		"ol": [
			"type",
			"compact",
			"start"
		],
		"#p": [
			"align"
		],
		"pre": [
			"width"
		],
		"q": [
			"cite"
		],
		"svg": [
			"viewBox",
			"contenteditable"
		],
		"g": [
			"fill",
			"stroke",
			"transform"
		],
		"path": [
			"fill",
			"stroke",
			"stroke-dasharray",
			"d"
		],
		"text": [
			"fill",
			"font-family",
			"font-size"
		],
		"tspan": [
			"x",
			"y",
			"class"
		],
		"table": [
			"align",
			"bgcolor",
			"border",
			"cellpadding",
			"cellspacing",
			"summary",
			"width"
		],
		"tbody": [
			"align",
			"char",
			"charoff",
			"span",
			"valign"
		],
		"td": [
			"abbr",
			"align",
			"bgcolor",
			"char",
			"charoff",
			"colspan",
			"height",
			"nowrap",
			"rowspan",
			"span",
			"valign",
			"width"
		],
		"tfoot": [
			"align",
			"char",
			"charoff",
			"span",
			"valign"
		],
		"th": [
			"abbr",
			"align",
			"bgcolor",
			"char",
			"charoff",
			"colspan",
			"height",
			"nowrap",
			"rowspan",
			"span",
			"valign",
			"width"
		],
		"thead": [
			"align",
			"char",
			"charoff",
			"span",
			"valign"
		],
		"tr": [
			"align",
			"bgcolor",
			"char",
			"charoff",
			"span",
			"valign"
		],
		"ul": [
			"compact",
			"type"
		]
	}
}